// Reports API — calls the local Mockoon mock server
// (apps/app/mocks/lendcord.mockoon.json, run via `pnpm mock:api`) at API_URL.
// TODO: point API_URL at the real backend once the reports page has a live
// API. Call sites elsewhere shouldn't need to change.

import { baseApi } from "@/app/store/baseApi";
import type { ReportsList } from "@/features/reports/reports.types";

export const reportsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getReports: builder.query<ReportsList, void>({
      query: () => ({ url: "/api/lender/reports" }),
      providesTags: ["Report"],
    }),
  }),
});

export const { useGetReportsQuery } = reportsApi;
